import _slicedToArray from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { unpack } from '../../utils/index.js';
var min = Math.min,
  max = Math.max;
/*
 * supported arguments:
 * - rgb2hsv(r,g,b)
 * - rgb2hsv([r,g,b])
 * - rgb2hsv({r,g,b})
 */
var rgb2hsl = function rgb2hsl() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  args = unpack(args, 'rgb');
  var _args = args,
    _args2 = _slicedToArray(_args, 3),
    r = _args2[0],
    g = _args2[1],
    b = _args2[2];
  var min_ = min(r, g, b);
  var max_ = max(r, g, b);
  var delta = max_ - min_;
  var h, s, v;
  v = max_ / 255.0;
  if (max_ === 0) {
    h = Number.NaN;
    s = 0;
  } else {
    s = delta / max_;
    if (r === max_) h = (g - b) / delta;
    if (g === max_) h = 2 + (b - r) / delta;
    if (b === max_) h = 4 + (r - g) / delta;
    h *= 60;
    if (h < 0) h += 360;
  }
  return [h, s, v];
};
export default rgb2hsl;